import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'

export const ConfirmMessage = () => (
  <NoticeBox
    title='Bets cannot be cancelled once confirmed.'
    noticeBoxType='Info'
    hasBorder={false}
  />
)
